import React, {Component, Fragment} from 'react';
import {autobind} from 'core-decorators';
import {graphql, compose} from 'react-apollo';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import deleteAttendee from 'graphql/mutations/orders/delete-attendee.gql';
import Spinner from 'components/spinner';
import AttendeeExportData from '../attendee-export';
import styles from './styles.css';

@compose(graphql(deleteAttendee, {
    props: ({mutate}) => ({
        onSubmit: variables => mutate({variables}),
    }),
}))
@autobind
export default class AttendeeData extends Component {
    static propTypes = {
        attendees: PropTypes.array.isRequired,
        orderDataQuery: PropTypes.any,
        orderId: PropTypes.number,
    };

    state = {}

    async handleAttendeeRemove(id) {
        this.setState({loading: true, errors: undefined});
        const response = await this.props.onSubmit({id});
        if (response.data.deleteAttendee.errors) {
            this.setState({
                loading: false,
                errors: response.data.deleteAttendee.errors,
            });
        } else {
            this.setState({
                loading: false,
            });
            this.props.orderDataQuery.refetch();
        }
    }

    render() {
        if (this.state.loading === true) return <Spinner />;

        return (
            <div>
                <table className={styles.root}>
                    <thead className={styles.header}>
                        <tr>
                            <th>Nombre</th>
                            <th>Apellido</th>
                            <th>Razón social</th>
                            <th>CUIT</th>
                            <th />
                        </tr>
                    </thead>
                    <tbody>
                        {this.props.attendees.map((attendee, index) => {
                            const bgClass = index % 2 !== 0 ? styles.odd : styles.even;
                            return (
                                <Fragment key={attendee.id}>
                                    <tr className={classNames(styles.row, bgClass)}>
                                        <td>
                                            {attendee.firstName}
                                        </td>
                                        <td>
                                            {attendee.lastName}
                                        </td>
                                        <td>
                                            {attendee.legalName}
                                        </td>
                                        <td>
                                            {attendee.cuit}
                                        </td>
                                        <td className={styles.tdDelete}>
                                            {this.props.orderDataQuery.order.status.id !== 'invoice_approved' && (
                                                <button
                                                    className={styles.delete}
                                                    onClick={() => this.handleAttendeeRemove(attendee.id)}
                                                />
                                            )}
                                        </td>
                                    </tr>
                                </Fragment>
                            );
                        })}
                    </tbody>
                </table>
                {this.props.attendees.length > 0 && (
                    <AttendeeExportData attendees={this.props.attendees} orderId={this.props.orderId} />
                )}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./views/order-detail/attendee-data/index.js